import React from 'react';  
import './Grid1.css';  




import productImg01 from "../../../assets/images/oled48.png";
import productImg02 from "../../../assets/images/xl7s.png";

import productImg03 from "../../../assets/images/1800BTU.png";
import productImg04 from "../../../assets/images/RF6_1.png";
import img11 from '../../../assets/images/africa-computerelectronics-supercategory-9.jpg';
import img21 from "../../../assets/images/winter-sports-concept-composition.59e504a787b9d4d098dc.jpg";
import img31 from '../../../assets/images/view-woman-gas-station.b211a1d2da70eacbfa8e.jpg';
import img41 from '../../../assets/images/full-shot-couple-dog-home.a65754f1aee13f0c2e83.jpg';
import img51 from '../../../assets/images/corredo_banner_3.jpg';
import { Link } from 'react-router-dom';






const products = [  
  { id: 1, name: "48 OLED 48C26LA SMART " , desc: 'TV', image: productImg01, lien:'/shop/78' },  
  { id: 2, name: 'BLUETOOTH SPEAKER XL5S', desc: 'Audio', image: productImg02, lien:'/shop/09' },  
  { id: 3, name: 'DUALCOOL Anti-Moustique', desc: 'Climatiseur', image: productImg03, lien:'/shop/60' },  
  { id: 4, name: 'REF 4 DOORS GC-X22FTQLL', desc: 'Refrigerateur', image: productImg04, lien:'/shop/54' },
];  

function Grid1() {  
  return (  
    <div className="grid-container_grid">  
      {products.map(product => (  
        <div className="grid-item_grid" key={product.id}>  
        <Link to={product.lien}>
          <img src={product.image} alt={product.name} className="product-image_grid" />  
          <h3 className='hover-text mb- t-2'>{product.name}</h3>
          <p className='hover-text justify-center mb-3 '>{product.desc}</p>  
          <button className="buy-button mb-3">VOIR DETAIL</button>  </Link>
        </div>  
      ))}  
    </div>  
  );  
}  

export default Grid1;